var render = function render() {
  var _vm$State$config, _vm$State$config$feat, _vm$State$config2, _vm$State$config2$fea;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.State.showFootBar,
      expression: "State.showFootBar"
    }],
    attrs: {
      "id": "foot"
    }
  }, [_vm.State.showAISpeech && (_vm$State$config = _vm.State.config) !== null && _vm$State$config !== void 0 && (_vm$State$config$feat = _vm$State$config.features) !== null && _vm$State$config$feat !== void 0 && _vm$State$config$feat.stt ? _c('div', {
    staticClass: "aiSpeechPop",
    on: {
      "click": _vm.showAISpeechPop
    }
  }, [_c('span', {
    staticClass: "loader"
  })]) : _vm._e(), _c('div', {
    staticClass: "optionBox scrollbar"
  }, [_vm.showIconArray.includes('leaveParty') ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "placement": "top",
      "content": _vm.$t('partylineGuest.leave')
    }
  }, [_c('i', {
    staticClass: "iconfont icon-a-V2hangupoff m_r_40",
    on: {
      "click": _vm.showDialog
    }
  })]) : _vm._e(), !_vm.userInfo.owner ? _c('el-divider', {
    staticClass: "footivider",
    attrs: {
      "direction": "vertical"
    }
  }) : _vm._e(), _vm.showIconArray.includes('camera') ? _c('div', {
    staticClass: "deviceIconBox m_r_40"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.showDeviceTips('camera', _vm.camera, _vm.devicesInfo),
      "placement": "top"
    }
  }, [_vm.camera && _vm.cameraDevice.length ? _c('i', {
    staticClass: "iconfont icon-a-V2cameraon",
    on: {
      "click": function ($event) {
        return _vm.setCameraOrMic('muteVideo', false);
      }
    }
  }) : _c('i', {
    staticClass: "iconfont icon-a-V2cameraoff",
    on: {
      "click": function ($event) {
        return _vm.setCameraOrMic('muteVideo', true);
      }
    }
  })]), _c('device-select', {
    attrs: {
      "deviceState": !_vm.camera,
      "title": _vm.$t('operationBtn.selectCamera'),
      "type": "video",
      "deviceSelectId": _vm.devicesInfo.cameraId,
      "data": _vm.cameraDevice
    },
    on: {
      "changeDevice": _vm.changeDevice,
      "updateDeviceId": _vm.updateDeviceId
    }
  })], 1) : _vm._e(), _vm.showIconArray.includes('mic') ? _c('div', {
    staticClass: "deviceIconBox m_r_40"
  }, [_c('audioCheck', {
    attrs: {
      "mic": _vm.mic,
      "microphoneId": _vm.devicesInfo.microphoneId,
      "devicesInfo": _vm.devicesInfo,
      "localVolume": _vm.localVolume,
      "rtc": _vm.rtc,
      "osLevelmicMuted": _vm.osLevelmicMuted
    },
    on: {
      "callback": _vm.controlAudio
    }
  }), _c('device-select', {
    attrs: {
      "title": _vm.$t('operationBtn.selectMicrophone'),
      "type": "audio",
      "deviceSelectId": _vm.devicesInfo.microphoneId,
      "data": _vm.microphoneDevice,
      "rtilCode": _vm.rtilCode,
      "userInfoRtilcode": _vm.userInfo.rtilCode
    },
    on: {
      "changeDevice": _vm.changeDevice,
      "updateDeviceId": _vm.updateDeviceId
    }
  })], 1) : _vm._e(), _vm.showIconArray.includes('hearMyself') ? _c('div', {
    staticClass: "deviceIconBox m_r_40",
    class: {
      hide: !_vm.startHearSelf
    }
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.hearSelfTips,
      "placement": "top"
    }
  }, [_vm.mic && _vm.microphoneDevice.length && _vm.canHearSelf ? _c('i', {
    staticClass: "iconfont icon-a-hearself-on",
    on: {
      "click": function ($event) {
        return _vm.controlHearSelf('closeFeature');
      }
    }
  }) : _c('i', {
    staticClass: "iconfont icon-a-hearself-off",
    class: {
      closeIcon: !_vm.canHearSelf,
      notAllowed: !_vm.mic
    },
    on: {
      "click": function ($event) {
        return _vm.controlHearSelf('openFeature');
      }
    }
  })])], 1) : _vm._e(), _vm.showIconArray.includes('speaker') ? _c('div', {
    staticClass: "deviceIconBox m_r_40"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.turnTips(!_vm.isMute, _vm.$t('operationBtn.speaker')),
      "placement": "top"
    }
  }, [!_vm.isMute ? _c('i', {
    staticClass: "iconfont icon-a-V2speakeron",
    on: {
      "click": function ($event) {
        return _vm.changeMute(true);
      }
    }
  }) : _c('i', {
    staticClass: "iconfont icon-a-V2speakeroff",
    on: {
      "click": function ($event) {
        return _vm.changeMute(false);
      }
    }
  })]), _c('device-select', {
    attrs: {
      "title": _vm.$t('operationBtn.selectSpeaker'),
      "type": "speaker",
      "deviceSelectId": _vm.devicesInfo.speakerId,
      "data": _vm.speakerDevice
    },
    on: {
      "changeDevice": _vm.changeDevice,
      "updateDeviceId": _vm.updateDeviceId
    }
  })], 1) : _vm._e(), _vm.State.talkbackStatus && (_vm.$route.name == 'party' || _vm.$route.name == 'partyParticipate') ? _c('div', {
    staticClass: "deviceIconBox m_r_40"
  }, [_c('LazyAudio', {
    attrs: {
      "userInfo": _vm.userInfo,
      "liveInfo": _vm.liveInfo,
      "rtilCode": _vm.rtilCode,
      "talkBackInfo": _vm.talkBackInfo,
      "isHost": true
    },
    on: {
      "callback": _vm.lazyAudioCallback
    }
  })], 1) : _vm._e(), _vm.showIconArray.includes('share') ? _c('div', {
    staticClass: "deviceIconBox m_r_40"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.isShare ? _vm.$t('operationBtn.stopShareScreen') : _vm.$t('operationBtn.shareScreen'),
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-a-V2sharescreen",
    class: {
      active: _vm.isShare
    },
    on: {
      "click": function ($event) {
        return _vm.shareScreen(_vm.isShare ? {
          type: 'stopShare'
        } : {
          type: 'share'
        });
      }
    }
  })])], 1) : _vm._e(), _vm.showIconArray.includes('multiTypeshare') ? _c('div', {
    staticClass: "deviceIconBox m_r_40 multiTypeshare"
  }, [_vm.currentTypeShare ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$t('operationBtn.stopShareScreen'),
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-a-V2sharescreen",
    class: {
      active: _vm.currentTypeShare
    },
    on: {
      "click": function ($event) {
        return _vm.shareScreen({
          type: 'stopShare'
        });
      }
    }
  })]) : _vm._e(), !_vm.currentTypeShare ? _c('el-popover', {
    attrs: {
      "placement": "bottom",
      "title": _vm.$t('kioskHost.displayLocation'),
      "width": "200",
      "popper-class": "shareSelect",
      "trigger": "click"
    }
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "slot": "reference",
      "effect": "dark",
      "content": _vm.$t('operationBtn.shareScreen'),
      "placement": "top"
    },
    slot: "reference"
  }, [_c('i', {
    staticClass: "iconfont icon-a-V2sharescreen"
  })]), _c('ul', {
    staticClass: "select"
  }, [_c('li', {
    class: {
      active: _vm.currentTypeShare == 'pip'
    },
    on: {
      "click": function ($event) {
        return _vm.shareScreen({
          type: 'pip'
        });
      }
    }
  }, [_vm.currentTypeShare == 'pip' ? _c('i', {
    staticClass: "el-icon-check"
  }) : _vm._e(), _vm._v(_vm._s(_vm.$t('kioskHost.asPip')))]), _c('li', {
    class: {
      active: _vm.currentTypeShare == 'mainWindow',
      disabled: _vm.disabled.includes('shareAsMainwindow')
    },
    on: {
      "click": function ($event) {
        return _vm.shareScreen({
          type: 'mainWindow'
        });
      }
    }
  }, [_vm.currentTypeShare == 'mainWindow' ? _c('i', {
    staticClass: "el-icon-check"
  }) : _vm._e(), _vm._v(_vm._s(_vm.$t('kioskHost.asMainWinddow')))])])], 1) : _vm._e()], 1) : _vm._e(), _vm.showIconArray.includes('chat') ? _c('div', {
    staticClass: "deviceIconBox m_r_40"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$t('operationBtn.chat'),
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "pointer icon-a-V2chat iconfont",
    class: {
      unread: _vm.showUnread,
      active: _vm.showChat
    },
    on: {
      "click": _vm.showChatModule
    }
  })])], 1) : _vm._e(), _vm.showIconArray.includes('raiseHand') ? _c('div', {
    staticClass: "deviceIconBox m_r_40"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$t('galleryParticipant.applyChat'),
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-a-V2raisehand pointer",
    class: {
      active: this.hasSetRaiseHand
    },
    on: {
      "click": _vm.setRaiseHand
    }
  })])], 1) : _vm._e(), _vm.showIconArray.includes('publicChat') && _vm.userInfo.role == 2 ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$t('conferenceParticipant.applyPubHost'),
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-a-V2raisehand pointer",
    class: {
      active: this.hasSetRaiseHand
    },
    on: {
      "click": _vm.setPublicChat
    }
  })]) : _vm._e(), _vm.showIconArray.includes('fullScreen') && _vm.showPipFullScreen ? _c('div', {
    staticClass: "deviceIconBox"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.pipsListFullScreen ? _vm.$t('galleryHost.exitFullScreen') : _vm.$t('galleryHost.fullScreen'),
      "placement": "bottom"
    }
  }, [_c('div', {
    staticClass: "fullScreenBtn pointer"
  }, [_c('i', {
    staticClass: "iconfont icon-full_screen",
    on: {
      "click": _vm.fullScreenFn
    }
  })])])], 1) : _vm._e(), _vm.State.showAISpeech && (_vm$State$config2 = _vm.State.config) !== null && _vm$State$config2 !== void 0 && (_vm$State$config2$fea = _vm$State$config2.features) !== null && _vm$State$config2$fea !== void 0 && _vm$State$config2$fea.stt ? _c('div', {
    staticClass: "deviceIconBox m_r_40"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$t('operationBtn.voice'),
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "pointer icon-Subtract iconfont",
    class: {
      active: _vm.showAISpeech
    },
    on: {
      "click": _vm.showVoiceModule
    }
  })])], 1) : _vm._e(), _vm._l(_vm.State.groupList, function (item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.showGroupList,
        expression: "showGroupList"
      }],
      key: index,
      staticClass: "deviceIconBox m_r_40"
    }, [_c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "placement": "top"
      },
      scopedSlots: _vm._u([{
        key: "content",
        fn: function () {
          return [_c('div', {
            domProps: {
              "innerHTML": _vm._s(_vm.showPushTalkTips(item, index))
            }
          })];
        },
        proxy: true
      }], null, true)
    }, [_c('i', {
      staticClass: "pointer icon-pushTalk pushTalk iconfont",
      class: {
        active: _vm.State.pressShortCut == index + 1,
        disabled: _vm.State.pushTalking && _vm.State.pressShortCut != index + 1
      },
      on: {
        "mousedown": function ($event) {
          return _vm.mouseDown(item, index, $event);
        },
        "mouseup": function ($event) {
          return _vm.mouseUp(item, $event);
        }
      }
    }, [_c('div'), _c('div')])]), _c('el-tooltip', {
      attrs: {
        "popper-class": "footPushTalkPopper",
        "effect": "dark",
        "placement": "top"
      }
    }, [_c('i', {
      staticClass: "el-icon-arrow-up"
    }), _c('div', {
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('div', {
      staticClass: "titleBox"
    }, [_c('span', {
      staticClass: "title",
      attrs: {
        "title": _vm.showGroupName(item, index)
      }
    }, [_vm._v(_vm._s(_vm.showGroupName(item, index)))]), _c('span', {
      staticClass: "groupNumber"
    }, [_vm._v(_vm._s(_vm.showGroupNumber(item)))])]), _vm._l(item.rtilCodeList, function (rtilCode, index) {
      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.State.allRtilCodeArray.includes(rtilCode),
          expression: "State.allRtilCodeArray.includes(rtilCode)"
        }],
        key: index,
        staticClass: "memberName"
      }, [_vm._v(" " + _vm._s(_vm.State.globalNameInfo[rtilCode]) + " "), rtilCode == _vm.userInfo.rtilCode ? _c('span', [_vm._v("(" + _vm._s(_vm.$t('aiSpeech.me')) + ")")]) : _vm._e()]);
    })], 2)])], 1);
  })], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };